module.exports = __webpack_public_path__ + "static/media/Teeth – 1.f462635d.jpg";